var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKingSection2Icon3 = function SvgKingSection2Icon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.987 6.136 36.944 24.77h76.291L77.192 6.136a4.578 4.578 0 0 0-4.205 0Z",
    fill: "#33A0FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "king-section2-icon-3_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 70,
    width: 109,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.625 70.073H128.95v4.744H20.625v-4.744Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#king-section2-icon-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.572 74.817H22.003a1.378 1.378 0 0 1-1.378-1.378v-1.988c0-.761.617-1.378 1.378-1.378h105.569c.761 0 1.378.617 1.378 1.378v1.988c0 .762-.617 1.378-1.378 1.378Z",
    fill: "#B3C3CE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.157 67.408h7.462V29.034h-7.462v38.374ZM61.904 67.408h7.462V29.034h-7.462v38.374ZM80.742 67.408h7.462V29.034h-7.462v38.374ZM99.488 67.408h7.462V29.034h-7.462v38.374Z",
    fill: "#CFDDE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.602 33.233h-7.427a1.659 1.659 0 0 1-1.658-1.66v-1.658H52.26v1.659c0 .916-.742 1.659-1.658 1.659ZM69.348 33.233h-7.427a1.658 1.658 0 0 1-1.658-1.66v-1.658h10.744v1.659c0 .916-.743 1.659-1.659 1.659ZM88.186 33.233H80.76a1.659 1.659 0 0 1-1.659-1.66v-1.658h10.744v1.659c0 .916-.743 1.659-1.659 1.659ZM106.932 33.233h-7.426a1.659 1.659 0 0 1-1.659-1.66v-1.658h10.744v1.659c0 .916-.742 1.659-1.659 1.659ZM99.541 61.61h7.427c.916 0 1.658.743 1.658 1.659v1.658H97.882v-1.658c0-.916.743-1.659 1.66-1.659ZM80.795 61.61h7.427c.915 0 1.658.743 1.658 1.659v1.658H79.136v-1.658c0-.916.743-1.659 1.659-1.659ZM61.957 61.61h7.426c.916 0 1.659.743 1.659 1.659v1.658H60.298v-1.658c0-.916.742-1.659 1.659-1.659ZM43.21 61.61h7.427c.916 0 1.658.743 1.658 1.659v1.658H41.552v-1.658c0-.916.742-1.659 1.658-1.659Z",
    fill: "#08F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.577 63.677h-75.58a3.844 3.844 0 0 0-3.843 3.844v2.552h83.267V67.52a3.844 3.844 0 0 0-3.844-3.844ZM34.812 31.165a1.659 1.659 0 0 1-1.658-1.658v-5.21c0-.917.742-1.66 1.658-1.66h79.95c.916 0 1.659.743 1.659 1.66v5.21c0 .916-.743 1.658-1.659 1.658h-79.95Z",
    fill: "#CFDDE9"
  })));
};
export default SvgKingSection2Icon3;